module.exports = " <ul class=filters _v-dace2e5c=\"\"> <li :class=\"{'active': !filter}\" @click=setFilter(null) _v-dace2e5c=\"\">Alle</li> <li v-for=\"_filter in sortedFilters\" :class=\"{'active': _filter === filter}\" @click=setFilter(_filter) _v-dace2e5c=\"\"> {{_filter}} </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-dace2e5c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Filters.vue
// module id = 764
// module chunks = 2